import { useEffect, useState } from 'react'
import { setOffsetAndProductIdInUrl } from './setOffsetAndProductIdInUrl'
import { useSearchStore } from '../../store/SearchStore'

const setPageOffset = setOffsetAndProductIdInUrl as (offset: number) => void

export const usePagingOffset = ({ loaded }: { loaded: boolean }) => {
  const offset = useSearchStore(state => state.initialOffset)
  const galleryPageSize = useSearchStore(state => state.galleryPageSize)
  const [currentPageNumber, setCurrentPageNumber] = useState(
    offset / galleryPageSize + 1,
  )

  useEffect(() => {
    window.history.scrollRestoration = 'manual'
  }, [offset])

  const offsetBorderApproaching = (productIndex: number) => {
    /* istanbul ignore next */
    if (loaded) {
      setPageOffset(productIndex)
      setCurrentPageNumber(productIndex / galleryPageSize + 1)
    }
  }

  return { currentPageNumber, offsetBorderApproaching }
}
